import { http } from "@/lib/api";

const d = (p) => p.then((r) => r.data);

export const musicApi = {
  config: () => d(http.get("/music/config")),
  projects: () => d(http.get("/music/projects")),
  createProject: (name) => d(http.post("/music/projects", { name })),
  renameProject: (id, name) => d(http.put(`/music/projects/${id}`, { name })),
  deleteProject: (id) => d(http.delete(`/music/projects/${id}`)),
  references: () => d(http.get("/music/references")),
  uploadReference: (file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("rights_confirmed", "true");
    return d(http.post("/music/references/upload", fd, { onUploadProgress: (e) => onProgress?.(e.total ? Math.round((e.loaded * 100) / e.total) : 0) }));
  },
  youtubeReference: (body) => d(http.post("/music/references/youtube", { ...body, rights_confirmed: true })),
  deleteReference: (id) => d(http.delete(`/music/references/${id}`)),
  tracks: (projectId) => d(http.get("/music/tracks", { params: projectId ? { project_id: projectId } : {} })),
  generate: (body) => d(http.post("/music/generate", body)),
  regenerate: (id) => d(http.post(`/music/tracks/${id}/regenerate`)),
  retry: (id) => d(http.post(`/music/tracks/${id}/retry`)),
  cancel: (id) => d(http.post(`/music/tracks/${id}/cancel`)),
  remove: (id) => d(http.delete(`/music/tracks/${id}`)),
  rename: (id, name) => d(http.put(`/music/tracks/${id}`, { name })),
  edit: (id, body) => d(http.post(`/music/tracks/${id}/edit`, body)),
  blob: (path, params) => d(http.get(path, { params, responseType: "blob" })),
  stats: () => d(http.get("/music/admin/stats")),
  settings: () => d(http.get("/music/admin/settings")),
  saveSettings: (body) => d(http.put("/music/admin/settings", body)),
  takedowns: () => d(http.get("/music/admin/takedowns")),
  setTakedown: (id, status) => d(http.post(`/music/admin/takedowns/${id}/status`, { status })),
  reportTakedown: (body) => d(http.post("/music/takedown", body)),
};

export const errMsg = (e, fb = "Something went wrong") => {
  const v = e?.response?.data?.detail;
  if (Array.isArray(v)) return v.map((x) => x.msg).join(", ");
  return v || fb;
};

export const fmtTime = (s) => {
  const t = Math.max(0, Math.round(s || 0));
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
};

export async function downloadTrack(track, format) {
  const b = await musicApi.blob(`/music/tracks/${track.id}/file`, { format, download: true });
  const url = URL.createObjectURL(b);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${track.title} v${track.version || 1}.${format}`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
